import{ useContext, useState } from "react";
import { AuthContext } from "../context/authContext";
import axiosObject from "../service/axios";

export const useAxiosGetRefreshing = (callback) => {
    const [isLoading, setIsLoading] = useState(false);
    const {setIsAuthenticated} = useContext(AuthContext);
    const fetching = async function(url){
        setIsLoading(true);
        await axiosObject.get(url).then(
                function (response){
                responseInterpreter(response, callback, setIsAuthenticated);
            }
        )
        .finally(()=>setIsLoading(false));
    }
    return [fetching, isLoading];
}

export const useAxiosDeleteRefreshing = (callback) => {
    const [isLoading, setIsLoading] = useState(false);
    const { setIsAuthenticated } = useContext(AuthContext);
    const fetching = async function (url) {
        setIsLoading(true);
        await axiosObject.delete(url).then(
            function (response) {
                responseInterpreter(response, callback, setIsAuthenticated);
            }
        )
            .finally(() => setIsLoading(false));
    }
    return [fetching, isLoading];
}

export const useAxiosPatchRefreshing = (callback) => {
    const [isLoading, setIsLoading] = useState(false);
    const { setIsAuthenticated } = useContext(AuthContext);
    const fetching = async function (url, formData) {
        setIsLoading(true);
        await axiosObject.patch(url,formData).then(
            function (response) {
                responseInterpreter(response, callback, setIsAuthenticated);
            }
        )
            .finally(() => setIsLoading(false));
    }
    return [fetching, isLoading];
}

export const useAxiosPutRefreshing = (callback) => {
    const [isLoading, setIsLoading] = useState(false);
    const { setIsAuthenticated } = useContext(AuthContext);
    const fetching = async function (url, formData) {
        setIsLoading(true);
        await axiosObject.put(url, formData).then(
            function (response) {
                responseInterpreter(response, callback, setIsAuthenticated);
            }
        )
            .finally(() => setIsLoading(false));
    }
    return [fetching, isLoading];
}

export const useAxiosPostRefreshing = (callback) => {
    const [isLoading, setIsLoading] = useState(false);
    const { setIsAuthenticated } = useContext(AuthContext);
    const fetching = async function(url, body){
        setIsLoading(true);
        await axiosObject.post(url, body).then(
            function (response) {
                responseInterpreter(response, callback, setIsAuthenticated);
            }
        )
        .finally(()=>setIsLoading(false));
    }
    return [fetching, isLoading];
}

const responseInterpreter = function (response, callback, setIsAuthenticated) {
    if (!response){
        alert("Сервер не ответил на запрос.")
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        setIsAuthenticated(false);
        return
    }
    if (response.data!==""){
        if (!response.data.status) {
            if (response.data.errorData.code === 1010) {
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");
                setIsAuthenticated(false);
            }
            else {
                console.log("Получен ответ " + response.data.errorData.message + " и код " + response.data.errorData.code);
                if (response.data.errorData.code===1036){
                    
                }
                alert(response.data.errorData.message);
            }
        } else callback(response);
    }
    else {
        if (response.status === 401) {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            setIsAuthenticated(false);
        }
    }
}